import {
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { NavigationStart, Router } from "@angular/router";
import { Subject } from "rxjs";
import { finalize, takeUntil } from "rxjs/operators";
import { SpinService } from "../shared/services/spin-service.service";

@Injectable()
export class SpinInterceptor implements HttpInterceptor {
  private totalRequests = 0;
  private cancelPendingRequests = new Subject<void>();

  constructor(
    private spinService: SpinService,
    private router: Router,
  ) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart && !spinService.nbDisabled) {
        // If navigation starts, emit a value to cancel pending requests
        try {
          this.cancelPendingRequests.next();
        } catch (error) {
          console.log("catch cancel pending errors");
        }
      }
    });
  }

  intercept(request: HttpRequest<any>, next: HttpHandler) {
    this.totalRequests++;
    this.spinService.spin(true);

    return next.handle(request).pipe(
      takeUntil(this.cancelPendingRequests),
      finalize(() => {
        this.totalRequests--;
        if (this.totalRequests === 0) {
          this.spinService.spin(false);
        }
      }),
    );
  }
}
